export interface DigestInputSectionType {
  section: string;
}

/** Safely extract section definitions from a digest job's inputJson. */
export function getDigestInputSections(
  inputJson: unknown
): DigestInputSectionType[] {
  const sections = (inputJson as Record<string, unknown> | null)?.sections;
  if (!Array.isArray(sections)) return [];
  return sections as DigestInputSectionType[];
}
